import { render, staticRenderFns } from "./MenuItemSave.vue?vue&type=template&id=b3572ad6&scoped=true"
import script from "./MenuItemSave.vue?vue&type=script&lang=js"
export * from "./MenuItemSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3572ad6",
  null
  
)

export default component.exports